import { Switch, UIText1 } from '@cian/ui-kit';
import { IconActionChevronRight12 } from '@cian/ui-kit-design-tokens/icons';
import cx from 'clsx';
import * as React from 'react';

import * as styles from './styles/category.css';
import { ECategoryType } from '../../../../repositories/subscriptions/entities/entities/CategorySchema';

import type { TActiveScreen } from '../../../../store/activeScreen';
import type { ICategory, IIsActiveCategoryParams } from '../../../../store/categories';

//TODO: разобраться со стилями свг
//TODO: добавить свойства onClick и isSelected

export interface ICategoryStoreProps {
  currentCategoryName: string | null;
}

export interface ICategoryDispatchProps {
  changeActiveScreen(activeScreen: TActiveScreen): void;
  getSubscriptionList(categoryName: string): void;
  onChange(params: IIsActiveCategoryParams): void;
}

export type ICategoryOwnProps = ICategory;

export type ICategoryProps = ICategoryStoreProps & ICategoryDispatchProps & ICategoryOwnProps;

export function Category({
  currentCategoryName,
  categoryName,
  title,
  subtitle,
  isActive,
  hasItems,
  categoryType,
  categoryId,
  getSubscriptionList,
  onChange,
  changeActiveScreen,
}: ICategoryProps) {
  let actionComponent: React.ReactNode = '';

  if (hasItems) {
    actionComponent = <IconActionChevronRight12 />;
  } else {
    if (categoryType === ECategoryType.Toggle) {
      const params = { categoryName, isActive, categoryId, categoryTitle: title };

      actionComponent = <Switch defaultChecked={isActive} onChange={() => onChange(params)} />;
    }
  }

  return (
    <div
      data-testid="Category"
      id={categoryId?.toString()}
      className={cx(
        styles['category'],
        !hasItems && categoryType === ECategoryType.Toggle && styles['category--toggle'],
        currentCategoryName === categoryName && styles['selected'],
      )}
      onClick={() => {
        if (hasItems) {
          getSubscriptionList(categoryName);
          changeActiveScreen('subscriptions');
        }
      }}
    >
      <div data-testid="CategoryText">
        <UIText1>{title}</UIText1>
        {subtitle && <UIText1 color="text-secondary-default">{subtitle}</UIText1>}
      </div>

      {actionComponent}
    </div>
  );
}
